"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isChildrenFalsy = void 0;
const isChildrenFalsy = children => {
  return children === false || children === null || children === undefined || children === '' || Number.isNaN(children);
};
exports.isChildrenFalsy = isChildrenFalsy;